<template>
  <v-container fluid grid-list-md pa-2>
    <v-layout row wrap>
      <v-flex
        v-for="project in $store.state.ProjectStore.projects"
        :key="project.id"
        xs12
        sm6
        md4
        lg6
      >
        <v-card class="mx-auto" max-width="400">
          <v-img class="white--text" height="200px">
            <v-card-title class="align-end fill-height">{{
              project.name
            }}</v-card-title>
          </v-img>

          <v-card-text>
            <!-- <span>
              by
              {{
              project.Organization.name +
              ', ' +
              project.Organization.city +
              ', ' +
              project.Organization.country
              }}
            </span>-->
            <br />
            <br />
          </v-card-text>

          <v-card-actions>
            <v-btn text color="orange" @click="projectClick(project.id)"
              >MEDIA</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {},
  created: function() {
    this.$store.dispatch('ProjectStore/fetchProjects')
  },
  methods: {
    projectClick: function(projectId) {
      this.$store
        .dispatch('ProjectStore/setSelectedProject', projectId)
        .then(res => {
          this.$store
            .dispatch('MediaStore/setMediaContext', 'project', {
              root: true
            })
            .then(res => {
              this.$store
                .dispatch(
                  'MediaStore/fetchMedia',
                  this.$route.params.projectId,
                  {
                    root: true
                  }
                )
                .then(res => {
                  this.$router.push('/media/' + projectId).catch(err => {})
                })
            })
        })
    }
  }
}
</script>

<style scoped></style>
